import { Button, Text } from "@ucl/react-library";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

export const DontWantToChallenge = () => {
  const { t } = useTranslation("translation", {
    keyPrefix: "dontWantToChallenge",
  });

  const navigate = useNavigate();

  const handleReturnToCase = () => {
    navigate("/case");
  };

  return (
    <div className="flex flex-col gap-8 max-w-[600px]">
      <Text renderAs="h2" styleType="h4" fontWeight="semi-bold">
        {t("title")}
      </Text>

      <div className="flex flex-col gap-4">
        <Text.P size="large" fontWeight="semi-bold">
          {t("comingBackLaterTitle")}
        </Text.P>

        <Text.P size="large">{t("comingBackLaterDescription")}</Text.P>
      </div>

      <div className="flex flex-col gap-4">
        <Text.P size="large" fontWeight="semi-bold">
          {t("acceptingRedressTitle")}
        </Text.P>

        <Text.P size="large">{t("acceptingRedressDescription")}</Text.P>
      </div>

      <Button onClick={handleReturnToCase} fullWidth>
        {t("returnToCaseButton")}
      </Button>
    </div>
  );
};

export default DontWantToChallenge;
